import api from "../../api/api";
import API_URL from "../../api/url";

const SettingRequest = {
  getSettings: (values) =>
    api.get(`${API_URL.BASEURL}${API_URL.getSettings}`, {
      params: {
        page: values?.page,
        limit: values?.limit,
        search: values?.search,
      },
    }),
  getSettingDetail: (id) =>
    api.get(`${API_URL.BASEURL}${API_URL.settingDetails}/${id}`),
  createSetting: (values) =>
    api.post(`${API_URL.BASEURL}${API_URL.createSetting}`, values),
  updateSetting: (values) =>
    api.post(`${API_URL.BASEURL}${API_URL.updateSetting}`, values),
  deleteSetting: (id) =>
    api.post(`${API_URL.BASEURL}${API_URL.deleteSetting}/${id}`),
};

export default SettingRequest;
